// Auth
export const AUTH_REFRESH = '/api/v1/users/refresh'
export const AUTH_LOGIN = '/api/v1/auth/login'
export const AUTH_GOOGLE = '/api/v1/auth/google'
export const AUTH_GOOGLE_REGISTER = '/api/v1/auth/google/register'
export const AUTH_REGISTER = '/api/v1/user/auth/create'
export const AUTH_VERIFY_EMAIL = '/api/v1/auth/verification/verify'
export const AUTH_RESEND_CODE = '/api/v1/auth/verification/generateCode'
export const AUTH_FORGOT_PASSWORD = '/api/v1/auth/password/forgot'
export const AUTH_RESET_PASSWORD = '/api/v1/auth/password/reset'

// Upload
export const UPLOAD_SIGN = '/api/v1/upload/sign'

// User
export const USER_ME = '/api/v1/users/me'
export const USER_PROFILE = '/api/v1/users/me/profile'
export const USER_AVATAR = '/api/v1/users/me/avatar'
export const USER_PROFILE_COMPLETION = '/api/v1/users/me/profile/completion'
export const USER_SECURITY = '/api/v1/users/me/security'
export const USER_CHANGE_PASSWORD = '/api/v1/users/me/password/change'
export const USER_SET_PASSWORD = '/api/v1/users/me/password/set'
export const USER_DEVICES = '/api/v1/users/devices'
export const USER_DEVICES_REVOKE_ALL = '/api/v1/users/devices/revoke-all'
export const USER_DEVICE = (id: string) => `/api/v1/users/devices/${id}`

// Business
export const BUSINESS_CATEGORIES = '/api/v1/user/auth/business/categories'
export const BUSINESS = '/api/v1/users/me/business'
export const BUSINESS_LOGO = '/api/v1/users/me/business/logo'
export const BUSINESS_ONBOARDING_STATUS = '/api/v1/users/me/business/onboarding-status'
export const BUSINESS_TIMEZONES = '/api/v1/users/me/business/timezones'
export const BUSINESS_SCHEDULER_SLOTS = (timezone: string) =>
  `/api/v1/users/me/business/scheduler-slots?timezone=${encodeURIComponent(timezone)}`

// Contacts
export const CONTACTS = '/api/v1/contacts'
export const CONTACT = (id: string) => `/api/v1/contacts/${id}`
export const CONTACTS_IMPORT_PREVIEW = '/api/v1/contacts/import/preview'
export const CONTACTS_IMPORT = '/api/v1/contacts/import'

// Services
export const SERVICES = '/api/v1/services'
export const SERVICE = (id: string) => `/api/v1/services/${id}`
export const SERVICES_IMPORT_TEMPLATE = '/api/v1/services/import/template'
export const SERVICES_IMPORT_PREVIEW = '/api/v1/services/import/preview'
export const SERVICES_IMPORT = '/api/v1/services/import'

// Contact Visits
export const CONTACT_VISITS = (contactId: string) => `/api/v1/contacts/${contactId}/visits`
export const CONTACT_VISIT = (contactId: string, visitId: string) =>
  `/api/v1/contacts/${contactId}/visits/${visitId}`

// Nudge queue
export const NUDGE_QUEUE = '/api/v1/nudge/queue'
export const NUDGE_QUEUE_DETAIL = (id: string) => `/api/v1/nudge/queue/${id}`
export const NUDGE_QUEUE_NO_SHOW = (id: string) => `/api/v1/nudge/queue/${id}/no-show`

// Dev-only (only exists when backend runs with the "dev" Spring profile)
export const DEV_TRIGGER_SCANNER = '/api/v1/nudge/dev/trigger-scanner'

// Sandbox (landing-page test suite)
export const SANDBOX_SEND = '/api/v1/sandbox/send'
export const SANDBOX_QUOTA = '/api/v1/sandbox/quota'

// Admin
export const ADMIN_NUDGE_METRICS = '/api/v1/admin/nudge/metrics'
export const ADMIN_NUDGE_QUEUE   = '/api/v1/admin/nudge/queue'
export const ADMIN_AI_OBSERVABILITY = '/api/v1/admin/ai/observability'
export const ADMIN_OVERVIEW = '/api/v1/admin/overview'
export const ADMIN_SCHEDULER_SLOTS = '/api/v1/admin/scheduler/slots'
export const ADMIN_SCHEDULER_SLOT = (slotId: string) => `/api/v1/admin/scheduler/slots/${slotId}`
export const ADMIN_USERS = '/api/v1/admin/users'

// Billing — owner
export const BILLING_PLANS    = '/api/v1/billing/plans'
export const BILLING_CURRENT  = '/api/v1/billing/current'
export const BILLING_CHECKOUT = '/api/v1/billing/checkout'
export const BILLING_PORTAL   = '/api/v1/billing/portal'
export const BILLING_CANCEL   = '/api/v1/billing/cancel'
export const BILLING_RESUME   = '/api/v1/billing/resume'
export const BILLING_INVOICES = '/api/v1/billing/invoices'

// Admin — businesses
export const ADMIN_BUSINESSES        = '/api/v1/admin/businesses'
export const ADMIN_BUSINESSES_SEARCH = (q: string) =>
  `/api/v1/admin/businesses/search?q=${encodeURIComponent(q)}`
export const ADMIN_BUSINESS_DETAIL   = (id: string) =>
  `/api/v1/admin/businesses/${id}/detail`

// Billing — admin
export const ADMIN_BILLING_METRICS             = '/api/v1/admin/billing/metrics'
export const ADMIN_BILLING_SUBSCRIPTIONS       = '/api/v1/admin/billing/subscriptions'
export const ADMIN_BILLING_SUBSCRIPTION_REFUND = (id: string) => `/api/v1/admin/billing/subscriptions/${id}/refund`
export const ADMIN_BILLING_SUBSCRIPTION_CANCEL = (id: string) => `/api/v1/admin/billing/subscriptions/${id}/cancel`
export const ADMIN_BILLING_OVERRIDES           = '/api/v1/admin/billing/entitlement-overrides'
export const ADMIN_BILLING_OVERRIDE_BY_ID      = (id: string) => `/api/v1/admin/billing/entitlement-overrides/${id}`
export const ADMIN_BILLING_OVERRIDES_BY_BUSINESS = (businessId: string) =>
  `/api/v1/admin/billing/entitlement-overrides?businessId=${encodeURIComponent(businessId)}`
export const ADMIN_BILLING_SUBSCRIPTION_PLAN   = (id: string) => `/api/v1/admin/billing/subscriptions/${id}/plan`
export const ADMIN_BILLING_ASSIGN_PLAN         = '/api/v1/admin/billing/subscriptions/assign'
